import { render } from "./App.vue?vue&type=template&id=5c1b17b8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/astara-studio-02-UPLOAD-PROD/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__